import useEventListener from '@use-it/event-listener';
import { useCallback } from 'react';
import { setIsColumnLayoutMode } from '../redux/actions/commonActions';
import { selectPanelPositionSetting } from '../redux/reducers/selfDataReducer';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { getIsColumnLayoutMode, isColumnLayoutModeAvailable } from '../utils/layoutModeUtils';
export const LayoutModeChangeHandler = () => {
    const dispatch = useAppDispatch();
    const isColumnLayoutMode = useAppSelector((state) => state.common.isColumnLayoutMode);
    const panelPositionSetting = useAppSelector(selectPanelPositionSetting);
    const onVisibilityChange = useCallback(() => {
        if (document.visibilityState !== 'visible') {
            return;
        }
        if (!isColumnLayoutModeAvailable()) {
            return;
        }
        const newIsColumnLayoutMode = getIsColumnLayoutMode(panelPositionSetting);
        if (newIsColumnLayoutMode !== isColumnLayoutMode) {
            dispatch(setIsColumnLayoutMode(newIsColumnLayoutMode));
        }
    }, [dispatch, isColumnLayoutMode, panelPositionSetting]);
    useEventListener('visibilitychange', onVisibilityChange);
    return null;
};
